export default {"src":"/_next/static/media/cred.ab925f38.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};